import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: white;\n  border-bottom: 1px solid ", ";\n  margin-top: -8px;\n  min-width: 14ch;\n  padding: 8px 16px;\n  position: sticky;\n  top: -8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, forwardRef, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SelectContext from './SelectContext';
import SearchInput from '../FormInput/SearchInput';
import { mystic } from '../../styles/colors';
var SearchContainer = styled.div(_templateObject(), mystic);
var SelectSearchInput = forwardRef(function (props, ref) {
  var onChange = props.onChange;

  var _useContext = useContext(SelectContext),
      isOpen = _useContext.isOpen;

  var hasBeenOpened = useRef(isOpen); // Clears input when listbox closes

  useEffect(function () {
    // Sets hasBeenOpened to true only first time isOpen is true
    if (!hasBeenOpened.current) hasBeenOpened.current = isOpen;

    if (hasBeenOpened.current && !isOpen) {
      onChange({
        target: {
          value: SelectSearchInput.defaultProps.value
        }
      });
    }
  }, [isOpen]);
  return React.createElement(SearchContainer, null, React.createElement(SearchInput, _extends({}, props, {
    ref: ref,
    small: true,
    type: "text"
  })));
});
SelectSearchInput.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};
SelectSearchInput.defaultProps = {
  placeholder: 'Search...',
  value: ''
};
export default SelectSearchInput;